import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "devices",
  "use": "devices-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"devices\"><path d=\"M31 10h-3V5a1 1 0 00-1-1H1a1 1 0 00-1 1v18a1 1 0 001 1h12v2H9v2h10v-2h-4v-2h6v3a1 1 0 001 1h9a1 1 0 001-1V11a1 1 0 00-1-1zm-10 1v11H2V6h24v4h-4a1 1 0 00-1 1zm9 15h-7V12h7z\" /><circle cx=\"26.5\" cy=\"23.98\" r=\"1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/devices.svg
// module id = 8v2R
// module chunks = 39 44